import styled from 'styled-components'

export const Text = styled("div")`
  font-family: var(--regular);
  font-size: 18px;
  color: var(--text);
  margin-bottom: 25px;
`;
